import { render } from "./OnboardingInsights.vue?vue&type=template&id=41b084a0"
import script from "./OnboardingInsights.vue?vue&type=script&lang=js"
export * from "./OnboardingInsights.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__